<template> 
    <div class="con_content">
        <div class="container">
            <div class="container_top h_48">帖子评论</div>
            <!-- table组件 -->
            <div class="my_table">
                <Header class="my_title txt_l">
                    <span class='my_titleL'>
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                        筛选查询
                    </span>     
                </Header>
                <div class="my_search">
                    <Row class="search_row">  
                        <div  class="search_name">
                        模糊查询:  
                        </div>  
                        <Col span="4" class="listIpt">
                            <Input  ref='isFocuseA'    :maxlength='20'  class='ipt   top13'  placeholder="昵称/评论内容" @keyup.enter.native="searchFun" v-model="search">
                                <Button size="small"  @click='searchFun'  slot="append" icon="md-search"></Button>
                            </Input>
                        </Col>
                    </Row>      
                </div>
            </div>
            <!-- table组件 -->
            <div class="my_table  ">
                <Header class="my_title txt_l">
                    <span class="my_titleL">
                    <Icon class="fw_900 " type="ios-list" size='30'/>     
                        数据列表 
                    </span>
                    
                    <div class="ct_rgt">                      
                        <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> 
                    </div>
                </Header>
                <Table border :columns="columns1" :data="data1" ref='table'>
                
                    <!-- 头像 -->
                    <template slot-scope="{ row }" slot="image">
                        <div class="demo-avatar">
                            <Avatar v-if="row.image == null" icon="ios-person" size="large" />
                            <Avatar v-else  :src="row.image" size="large"/> 
                        </div>                        
                    </template>

                    <!-- 帖子详情 -->
                    <template slot-scope="{ row }" slot="xq">
                        <Button class="padlr5" size="small"  @click="atGuid=row.articleGuid;look1=true"  type="info" >详情</Button>
                    </template>
                    <!-- 按钮 -->
                    <template slot-scope="{ row }" slot="btn">
                        <Poptip trigger="hover"  content="查看">
                            <Button class="padlr5" size="small"  @click="guid=row.guid;look2=true"  type="info"    icon="md-search"  ></Button>
                        </Poptip>    
                        <Poptip trigger="hover"  content="删除">
                            <Button class="padlr5" size="small"  @click="guid=row.guid;userName=row.userName;delM=true;"  type="error"    icon="md-close"  ></Button>
                        </Poptip>    
                    </template>
                    
                </Table>
                <Footer>
                    <Page  :current.sync="page" :total="totalPage" :page-size='size'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer />
                </Footer>
            </div>
        </div>  
        <!-- 确认删除框 -->
        <Modal
            v-model="delM"
            title="提示"
            @on-ok="delOk"
            @on-cancel="delM=false"
            class-name="vertical-center-modal"
        >
            <p>确定删除{{userName}}的这条评论吗? </p>         
        </Modal>  

        <!-- 查看帖子详情-->
        <Modal
            v-model="look1"
            title = "帖子详情"
            class-name="vertical-center-modal"
            okText="关闭"
            cancelText=""
            closable
            >
            <div v-if='atGuid&&look1'>
                <Child  :child_guid='atGuid' :txtM_c='look1'></Child>
            </div>
        </Modal>
        <!-- 查看回复详情-->
        <Modal
            v-model="look2"
            width="1100"
            title = "回复详情"
            class-name="vertical-center-modal"
            okText="关闭"
            cancelText=""
            closable
        >
            <div v-if='guid&&look2'>
                <Child2  :child_guid='guid' :txtM_c='look2'></Child2>
            </div>
        </Modal>
    </div>
</template> 
<script> 
    import Child  from '../../child_vue/report_child.vue';
    import Child2 from '../../child_vue/comment_child.vue';
    export default {
        data () {
            return {
               atGuid: null,
               guid: null,
               search: '', 
               
               look1: false,
               look2: false,

               page: 1,
               size: 20,
               totalPage: 0,
               
               columns1: [],
               data1: [],
               delM: false,
               userName: null,
            }
        },
        computed: {
         
        },
        components:{
            Child:Child,
            Child2:Child2,
        },
        methods: {
            load(){
                let data = {
                    data: this.search,
                    page: this.page,
                    size: this.size
                }
                this.$myAjax.get('admin/service/trend/comment/data/get'+this.$ajaxNull.get(data)).then(res => {
                    let ajax = res.data.data;
                    this.totalPage = ajax.total;
                   
                    this.data1 = ajax.list;
                    this.columns1 = [
                        {title:'ID',key:'number',align:'center',minWidth:80,maxWidth:140},
                        {title:'用户昵称',key:'name',align:'center',minWidth:80,maxWidth:140},
                        {title:'头像',slot:'image',align:'center',width:100},
                        {title:'评论内容',key:'comment',render:(h,params) => {
                            return h('span',{
                                domProps:{
                                title: params.row.comment
                                }
                            },params.row.comment)
                        },align:'left',ellipsis: true},
                        {title:'帖子详情',slot:'xq',align:'center',width:100},
                        {title:'评论时间',key:'createTime',align:'center',width:180},
                        {title:'操作',slot:'btn',align:'center',width:120,fixed: 'right'}
                    ]
                })
            },
            searchFun(){
                this.load();
            },
          
            delOk(){
                this.$myAjax.delete('admin/service/trend/comment/delete?guid='+this.guid+'&route=/layout/user/postComment/del').then(res => {
                    this.load();
                })
            },
            change_page(index){
                this.load();
            },
            change_size(index){
                this.size = index;
                this.load();
            },
            exportData(){
                var that = this;
                that.$refs.table.exportCsv({
                    filename: '帖子评论',
                    original: false
                });
               
            },
        },
        mounted: function(){
            var that = this;
            this.load();
        }
    }
</script>  
<style>
    
</style>
     